import React from "react";
import AuthForm from "../components/AuthForm";

function AuthPage() {
    return (
        <div className="auth-hero">
            <div className="auth-hero-inner">
                <section className="auth-hero-left">
                    <div className="auth-hero-badge">🦷</div>
                    <h1 className="auth-hero-title">
                        Tooth <span className="text-tiffany">Talk</span>
                    </h1>
                    <p className="auth-hero-subtitle">
                        Conversation to clinical documentation in one click
                    </p>

                    <div className="auth-hero-content">
                        <h2>From Consult to Outcomes, Instantly.</h2>
                        <p>
                            Transform your natural conversations into comprehensive notes,
                            personal communication, confident teams, and sustainable growth.
                        </p>
                        <h3>Unlocking the potential in every patient interaction.</h3>
                        <p>
                            The patient conversation is a critical, yet untapped, data source in your office.
                            It contains everything from clinical observations to patient concerns that unlock
                            case acceptance. Yet, converting it into structured, actionable data is a manual,
                            inconsistent, and inefficient process.
                        </p>
                        <p>
                            This friction isn't just a time sink. It's a direct cap on your production potential
                            and a risk to clinical consistency.
                        </p>
                    </div>
                </section>

                <section className="auth-hero-right">
                    <div className="auth-card">
                        <h3 className="auth-card-title">Sign in</h3>
                        <AuthForm
                            title=""
                            modeOverride="login"
                            showModeToggle={false}
                            showResetPassword={true}
                            showGoogle={true}
                            showDebugActions={false}
                            layout="stacked"
                        />
                    </div>
                    <div className="auth-card">
                        <h3 className="auth-card-title">Create account</h3>
                        <AuthForm
                            title=""
                            modeOverride="signup"
                            showModeToggle={false}
                            showResetPassword={false}
                            showGoogle={false}
                            showDebugActions={false}
                            layout="stacked"
                        />
                    </div>
                </section>
            </div>
        </div>
    );
}

export default AuthPage;
